module.exports = __webpack_public_path__ + "img/66ne.3856d04a.svg";